module.exports = __webpack_public_path__ + "img/manage-security.85c27e2.svg";